import { SxProps } from '@mui/material/styles';
import Iconify from 'src/components/Iconify';

interface Props {
  icon: string;
  sx?: SxProps<{}>;
}

const DefaultSizeIconify: React.FC<Props> = ({ icon, sx }) => (
  <Iconify icon={icon} width={24} height={24} sx={sx} />
);

export default DefaultSizeIconify;
